import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María González', 'Carmen Rodríguez', 'Laura Martínez', 'Ana López', 'Sofía Hernández', 'Valentina Pérez', 'Isabella García', 'Camila Sánchez', 'Daniela Ramírez', 'Paula Torres', 'Elena Flores', 'Gabriela Díaz'];
const CITIES = ['Buenos Aires', 'Ciudad de México', 'Bogotá', 'Santiago', 'Lima', 'Montevideo', 'Córdoba', 'Medellín', 'Guadalajara', 'Rosario', 'Quito', 'Caracas', 'Asunción', 'San José'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      // Schedule next notification (random between 8-15 seconds + 4s display time)
      const nextDelay = Math.random() * (15000 - 8000) + 8000 + 4000;
      setTimeout(showNotification, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 z-50 animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-17">
      <div className="bg-white rounded-lg shadow-lg border border-amber-100 p-4 flex items-center gap-3 max-w-sm" data-id="element-18">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-19">
          <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-20" />
        </div>
        <div data-id="element-21">
          <p className="text-sm font-medium text-gray-900" data-id="element-22">
            {currentData.name} de {currentData.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-23">
            acaba de comprar{' '}
            <span className="font-semibold text-amber-600" data-id="element-24">
              Matemática sin Lágrimas
            </span>
          </p>
        </div>
      </div>
    </div>;
}